export const integrationsKeys = {
  all: () => ['INTEGRATION_LIST'] as const,
};
